import { QuoteException } from '@/domain/stripe/quote/exception/QuoteException'

export class InvalidQuoteItemException extends QuoteException {
}